import * as React from 'react';
import InputContainer from 'src/modules/commons/inputs/input/Input.container';
import ErrorMessagesComponent from 'src/modules/commons/error-messages/ErrorMessages.component';
import OfflineInvestor from 'src/entities/OfflineInvestor';
import ProjectUpdateOfflineInvestorCardContainer
  from 'src/modules/project/update/partials/round-information/ProjectUpdateOfflineInvestorCard.container';
import ProjectData from 'src/value-objects/ProjectData';

export interface ProjectOfflineInvestorsFormComponentProps {
  project: ProjectData;
  newOfflineInvestor: OfflineInvestor;
  handleChange: (key: string) => (value: string | File) => void;
  handleSubmit: () => void;
  errorMessage: {};
  success: boolean;
}

class ProjectOfflineInvestorsFormComponent extends React.Component<ProjectOfflineInvestorsFormComponentProps> {

  public render(): React.ReactNode {

    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <h5 className="deco-title f-s-18">
              Co-inversores
            </h5>
            <div className="gap-20"/>
          </div>
          {this.props.project.offlineInvestors.map((offlineInvestor, key) => (
            <div key={key}>
              <ProjectUpdateOfflineInvestorCardContainer
                project={this.props.project}
                offlineInvestor={offlineInvestor}
              />
            </div>
          ))}
          <div className="col-xs-6 col-md-6 col-lg-6">
            <div
              className={'simple-card tab text-center border-dashed b-primary-dark pointer accordion-toggle' +
              ' question-toggle collapsed pointer'}
              data-toggle="collapse"
              data-parent="#faqAccordion"
              data-target="#new-offline-investor"
              id="add-co-investor-button"
            >
              <h4 className="text-center f-s-16">
                <span className="span-white">
                  Añadir Co-inversor
                </span>
              </h4>
              <div className="deco-dashed border-bottom-dashed b-primary-dark"/>
            </div>
          </div>
        </div>
        <div id="new-offline-investor" className="simple-card collapse">
          <div className="row">
            <div className="gap-20"/>
            <div className="col-sm-4 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Nombre"
                  type="text"
                  value={this.props.newOfflineInvestor.name || ''}
                  onChange={(value) => this.props.handleChange('name')(value)}
                  required={true}
                />
              </div>
              <div className="gap-20"/>
            </div>
            <div className="col-sm-4 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Tipo de inversión"
                  type="text"
                  value={this.props.newOfflineInvestor.investmentType || ''}
                  onChange={(value) => this.props.handleChange('investmentType')(value)}
                  required={true}
                />
              </div>
              <div className="gap-20"/>
            </div>
            <div className="col-sm-4 col-md-4">
              <div className="md-input">
                <InputContainer
                  label="Importe"
                  type="number"
                  value={this.props.newOfflineInvestor.amountInvested.toString() || ''}
                  onChange={(value) => this.props.handleChange('amountInvested')(value)}
                  required={true}
                />
                <span className="euro-input icon-error-input"/>
              </div>
              <div className="text-right">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-placement="bottom"
                  onClick={(e) => this.props.handleSubmit()}
                >
                  Añadir
                </button>
                <div className="gap-10"/>
                <ErrorMessagesComponent
                  errorMessage={this.props.errorMessage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProjectOfflineInvestorsFormComponent;


// WEBPACK FOOTER //
// ./src/modules/project/update/partials/round-information/ProjectOfflineInvestorsForm.component.tsx